function o(t){let l,f="";t>=3600&&(l=Math.floor(t/3600),f+=`${l}:`);let r=Math.floor(t%3600/60);r<10&&(r=`0${r}`),f+=`${r}:`;let e=t%60;return e<10&&(e=`0${e}`),f+=e,f}export{o as f};
//# sourceMappingURL=formatDuration-es.js.map
